/**
 * Auth routing helpers — shared between Login, ProtectedRoute, and AdminRoute.
 *
 * `getSafeRedirect(raw)` — validates an incoming `?redirect=` value from the URL.
 * Rejects protocol-relative URLs (`//evil.com`), absolute URLs, or anything that
 * doesn't start with `/`. Falls back to `/` when the value is missing or unsafe.
 *
 * `buildLoginRedirect(location)` — builds the outgoing `<Navigate to=...>`
 * string that bounces an unauthenticated user to the login page while
 * preserving their intended destination.
 */

export function getSafeRedirect(rawRedirect) {
  if (!rawRedirect || !rawRedirect.startsWith('/') || rawRedirect.startsWith('//')) {
    return '/'
  }
  return rawRedirect
}

export function buildLoginRedirect(location) {
  const redirect = location.pathname + location.search
  return `/login?redirect=${encodeURIComponent(redirect)}`
}
